export enum TypeConnectionSocket {
    CONNECTED = '1001',
    DISCONNECT = '1002',
}